<p-dialog
class="dialog"
*ngIf="data.length > 0"
[(visible)]="show"
(onShow)="loadDataCamUrl()"
(visibleChange)="closeInfoDialog()"
[showHeader]="false"
[modal]="true"
[dismissableMask]="true"
[style]="{
  'max-width': '700px',
  'min-width': '800px',
  'max-height': '100%',
  'border-radius': '10px'
}"
>
  <i class="pi pi-times" (click)="closeInfoDialog()">
  </i>
  <div [class]="i!==data.length-1 && data.length>1 ? 'border-bottom-1' : ''" *ngFor="let item of data let i = index">
    <div [class]="data.length>1 ? 'py-2' : ''">
      <div class="-mt-3">
        <real-time-slider [data]="data"></real-time-slider>
      </div>
        <div [style]="{'cursor':'default'}" class="w-full flex justify-content-between mt-3 mb-4">
          <h1 class="font-bold text-lg">{{item.name}} - {{item.streetName}}</h1>
          <div class="icons flex align-items-center gap-2">
            <span
              *ngIf="item.groupId === GroupEnum.ESPIRITO_SANTO || item.groupId === GroupEnum.PRF || item.groupId === GroupEnum.SERRA_GAUCHA"
              [pTooltip]="!isButtonEnabled(item) ? getButtonTooltip(item) : ''"
              tooltipPosition="top"
              [showDelay]="300"
            >
              <p-button
                (onClick)="goToEquipment(item)"
                label="Acessar equipamento"
                [style]="{'height': '2rem'}"
                [disabled]="!isButtonEnabled(item)"
              ></p-button>
            </span>
            <real-time-data-icons
              (dialog)="showDialog(item.name)"
              (videoDisplay)="openVideo(i)"
              [showCamera]="item.camUrl?.startsWith('https') && (item.groupId && item.groupId!= GroupEnum.SERRA_GAUCHA && item.groupId!=GroupEnum.VIA_ARAUCARIA && item.groupId!=GroupEnum.PRF)"
              [showBoard]="item.groupId && item.groupId!= GroupEnum.VIA_ARAUCARIA && item.groupId!=GroupEnum.BR381"
            ></real-time-data-icons>
          </div>
        </div>
        <real-time-info-window-text
          [data]="item"
          (locationClick)="openEquipmentLocation($event)"
        ></real-time-info-window-text>
    </div>
  </div>
  </p-dialog>
  <div class="dialogDetails">
    <real-time-events-window
    [devices]="selectedDevicesByName"
    [(dialogShow)]="dialog"
    ></real-time-events-window>
  </div>
  <shared-video-dialog
    *ngIf="data[indexVideo]"
    [urlCam]="data[indexVideo].camUrl"
    [(videoDisplay)]="videoDisplay"
  ></shared-video-dialog>
